__turbopack_context__.v({
  "lesMillsLogoImg": "RNCp8W_lesMillsLogoImg",
});
